"use strict";
/* eslint-disable */
// tslint:disable
/**
 * Umbrella API
 * The API for the Umbrella webapp, including administration and user features.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: anton@cactuslab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
var Configuration = /** @class */ (function () {
    function Configuration(param) {
        if (param === void 0) { param = {}; }
        this.apiKey = param.apiKey;
        this.username = param.username;
        this.password = param.password;
        this.authorization = param.authorization;
        this.basePath = param.basePath;
    }
    return Configuration;
}());
exports.Configuration = Configuration;
